import React, { useState, useEffect,useContext } from 'react'
import { Box, Container, CssBaseline, Avatar, Typography, TextField, FormControlLabel, Button, Grid, Checkbox, MenuItem, Snackbar, Alert, Card, CardContent, Divider, CardActions } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { auth, app, database } from '../../../firebaseConfig';
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { collection, query, orderBy, onSnapshot, addDoc, getDocs } from "firebase/firestore"
import { useNavigate, Link } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import { AuthContext } from '../../../AuthProvider';
import AccessDinied from '../../../components/AccessDinied';

function AddUser() {
    const {user}=useContext(AuthContext)
    const navigate = useNavigate()
    const [nom, setNom] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [type, setType] = useState('Utilisateur')
    const [localisation, setLocalisation] = useState('')
    const [chus, setChus] = useState([])
    const [errorData, setErrorData] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successData, setSuccessData] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
        setSuccessData(false)
    }
    const handleSubmit = async () => {
        setLoading(true)
        if (type == 'Utilisateur' && (localisation == '' || localisation == null)) {
            setLoading(false)
            setErrorData(true)
            setErrorMessage('Veuillez remplir les champs obligatoires')
            return
        }
        if (nom == '' || email == '' || password == '' || confirmPassword =='') {
            setLoading(false)
            setErrorData(true)
            setErrorMessage('Veuillez remplir les champs obligatoires')
            return
        }
        if(password != confirmPassword){
            setErrorData(true)
            setErrorMessage('Erreur lors de confirmation mot de passe')
            return
        }
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                updateProfile(user, {
                    displayName: nom,
                })
                setSuccessData(true)
                setSuccessMessage('Insertion réussie')
                setLoading(false)
                sendUser(user.uid).then((userID) => {
                    navigate('/admin/users')
                })
            })
            .catch((error) => {
                setLoading(false)
                setErrorData(true)
                setErrorMessage('Erreur lors de l\'enregistrement')
            
            });




    };
    useEffect(() => {
        const q = query(collection(database, 'chu'), orderBy('nom_chu', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setChus(querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })))
        })
    }, [])
    const sendUser = async (uid) => {
        try {
            const userDoc = await addDoc(collection(database, 'utilisateur'), {
                user_uid: uid,
                nom: nom,
                type: type,
                chu_id: localisation
            })
            return userDoc.id
        } catch (err) {
            alert(err)
            return err
        }
    }
    if(user.type !='Admin'){
        return <AccessDinied/>
    }
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden', height: 500 }}>
            <Typography variant='h5' sx={{ display: 'flex', justifyContent: 'center' }}>Ajout utilisateur</Typography>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, padding: 2 }}>
                <Card sx={{ maxWidth: 700 }}>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="nom"
                                    label="Nom complet"
                                    autoFocus
                                    onChange={(e) => {
                                        setNom(e.target.value)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    name="email"
                                    autoComplete="email"
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Mot de passe"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    onChange={(e) => {
                                        setPassword(e.target.value)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="confirmPassword"
                                    label="Confirmation mot de passe"
                                    type="password"
                                    id="confirmPassword"
                                    autoComplete="current-password"
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-select-currency"
                                    select
                                    label="Type"
                                    defaultValue={type}
                                    autoComplete="type"
                                    fullWidth
                                    required
                                    onChange={(e) => {
                                        setType(e.target.value)
                                        setLocalisation('')
                                    }}
                                    sx={{ mt: 2 }}


                                >
                                    <MenuItem key='0' value="Utilisateur">
                                        Utilisateur CHU
                                    </MenuItem>
                                    <MenuItem key='1' value="Responsable Centrale">
                                        Responsable Centrale
                                    </MenuItem >
                                    <MenuItem key='2' value="Admin">
                                        Admin
                                    </MenuItem >
                                </TextField>
                            </Grid>
                            {type == 'Utilisateur' && (
                                <Grid item xs={12}>

                                    <TextField
                                        id="outlined-select-currency"
                                        select
                                        label="CHU"
                                        defaultValue={localisation}
                                        autoComplete="chu"
                                        fullWidth
                                        sx={{ mt: 2 }}
                                        onChange={(e) => {
                                            setLocalisation(e.target.value)
                                        }}
                                    >
                                        {chus.map((chu) => (
                                            <MenuItem key={chu.id} value={chu.id}>
                                                {chu.nom_chu}
                                            </MenuItem >
                                        )

                                        )}
                                    </TextField>
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant='contained' size="small" color='error' component={Link} to='/admin/reservation'>Annuler</Button>
                        <LoadingButton variant='contained'
                            size="small"
                            color='success'
                            onClick={handleSubmit}
                            loading={loading}
                            loadingIndicator="Enregistrement…"
                        >
                            Ajouter
                        </LoadingButton>
                    </CardActions>

                </Card>
                <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={successData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {successMessage}
                    </Alert>
                </Snackbar>
            </div>
        </div>

    )
}

export default AddUser